import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ImagePreview } from '@app/entities/images/interfaces/image-preview';
import { ImagesService } from '@app/entities/images/services/images.service';
import { PaginatedResults } from '@app/interfaces/paginated-results';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { AddToFavorites, RemoveFromFavorites } from '../image';
import { DreamboxStateModel } from './dreambox-state.model';
import { LoadDreamboxImages } from './dreambox.actions';

@State<DreamboxStateModel>({
  name: 'dreambox',
  defaults: {
    page: 1,
  },
})
@Injectable()
export class DreamboxState {
  constructor(
    private imagesService: ImagesService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  @Action(LoadDreamboxImages, { cancelUncompleted: true })
  @ImmutableContext()
  loadDreamboxImages(
    { getState, setState }: StateContext<DreamboxStateModel>,
    { preserveResults }: LoadDreamboxImages,
  ) {
    const nextPage = preserveResults ? getState().page + 1 : 1;

    return this.imagesService.getFavorites(nextPage).pipe(
      tap((paginatedResults: PaginatedResults<ImagePreview>) => {
        return setState((state: DreamboxStateModel) => {
          state.page = nextPage;
          state.images = preserveResults
            ? [...(state.images || []), ...paginatedResults.results]
            : paginatedResults.results;
          state.totalCount = paginatedResults.count;

          return state;
        });
      }),
    );
  }

  @Action(AddToFavorites)
  @ImmutableContext()
  updateFavoriteStatus(
    { setState }: StateContext<DreamboxStateModel>,
    { imageId }: AddToFavorites,
  ) {
    setState((state: DreamboxStateModel) => {
      const image = state.images?.find(
        (image: ImagePreview) => image.id === imageId,
      );

      if (image) {
        image.is_favorite = true;
      }

      return state;
    });
  }

  @Action(RemoveFromFavorites)
  @ImmutableContext()
  removeFromFavorites(
    { setState }: StateContext<DreamboxStateModel>,
    { imageId }: RemoveFromFavorites,
  ) {
    setState((state: DreamboxStateModel) => {
      const image = state.images?.find(
        (image: ImagePreview) => image.id === imageId,
      );

      if (image) {
        image.is_favorite = false;
      }

      return state;
    });
  }
}
